import React, { useState, useContext, useRef } from "react";
import Radio from "../../CommonComponents/Radio";
import Button from "../../Button";
import UploadSvg from "../../../Svg/UploadIconsvg";
import DownloadSvg from "../../../Svg/Downloadsvg";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import constants from "../../../constants";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";
import { mkConfig, generateCsv, download } from "export-to-csv";

function UploadQns(Props) {
  const Alert = useContext(AlertContext);
  const { setIsLoaded, setShowNotify } = Alert;
  const axios = useAxiosPrivate();
  const { handleClose, getCatchBlockDetails } = useCommonFunctionHooks();
  const { getPreSignedUrl } = useS3FileManagement();

  const [fileLoaded, setFileLoaded] = useState(null);
  const [isNotSupoortedFile, setIsNotSupportedFile] = useState(false);

  const fileInputRef = useRef();

  const libTypeName = {
    2: "MCQ",
    11: "SQL",
    3: "Descriptive",
    1: "Content",
    4: "Assignment",
    5: "Coding Challenge",
  };

  const libType = parseInt(Props.libType);

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
    filename: "mcq_invalid_questions_data",
  });

  const handleExportRows = (rows) => {
    const csv = generateCsv(csvConfig)(rows);
    download(csvConfig)(csv);
  };

  const handleClearFile = () => {
    setFileLoaded(null);
  };

  const handleLoadFile = (e) => {
    const file = e.target?.files[0];
    if (file) {
      const extension = file.name.split(".").pop().toLowerCase();
      setFileLoaded(file);
      setIsNotSupportedFile(extension !== "xlsx" && extension !== "csv");
    }
    e.target.value = "";
  };
  

  const handleTemplateDownload = async () => {
    let URL = "";

    const fileMap = {
      [constants.libTypeIds.DESCRIPTIVE]: "Templates/TEMPLATE_SAQ_LAQ.xlsx",
      [constants.libTypeIds.MCQ]: "Templates/TEMPLATE_MCQ_SCQ.xlsx",
      default: "Templates/TEMPLATE_SQL.xlsx",
    };

    const filePath = fileMap[libType] || fileMap.default;

    if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
      URL = `../../../assets/files/${filePath.split("/")[1]}`;
    } else {
      let data = await getPreSignedUrl(filePath,undefined, filePath?.split(".")?.pop(), "GET");
      URL = data.url;
    }

    window.location.href = URL;
  };

  const triggerFileInput = () => fileInputRef.current?.click();

  const handleSubmitFile = async () => {
    if (!fileLoaded) return;

    const form = new FormData();
    form.append("mcq", fileLoaded);

    try {
      setIsLoaded(true);
      const response = await axios.post("node/admin/library/addviacsv", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setIsLoaded(false);

      const { resultCode, message, msg, data } = response.data;

      if (resultCode === constants.RESULT_STATUS.SUCCESS && !data) {
        Alert.setIsQuestionUploaded(true);
        setShowNotify({
          show: true,
          title: "Success",
          msg: message,
        });
      } else {
        if (data) {
          handleExportRows(data);
        }

        setShowNotify({
          show: true,
          title: "Warning",
          msg: msg,
        });
      }
    } catch (err) {
      setIsLoaded(false);
      getCatchBlockDetails(err);
    }
  };

  return (
    <div className="uploadgcatfbcont">
      <div className="downloadTemplate">
        <div className="textForTemplateCont">
          <p className="ntextfortemplate">
            We recommend you to use this template to add the {libTypeName[libType]} questions.
          </p>
        </div>
        <Button
          disable={false}
          icon={{
            type: "leading",
            icon: <DownloadSvg stroke="#667085" />,
          }}
          size={"sm"}
          onClick={handleTemplateDownload}
          hierarchy={{
            buttonText: "Download",
            type: "tertiaryGrey",
          }}
        />
      </div>

      <div>
        <div className={fileLoaded == null ? "upLoadTemplate" : "upLoadTemplateAfter"}>
          <div className="textForTemplateCont">
            <p className="ntextfortemplate">Supported format: .xlsx, .csv</p>
            {isNotSupoortedFile && (
              <p className="etextfortemplate">The uploaded file is not supported.</p>
            )}
          </div>

          {fileLoaded == null && (
            <div className="upload-div">
              <Button
                disable={false}
                icon={{
                  type: "leading",
                  icon: <UploadSvg stroke="#344054" />,
                }}
                size={"sm"}
                onClick={triggerFileInput}
                hierarchy={{
                  buttonText: "Upload",
                  type: "secondaryGrey",
                }}
              />
              <input
                ref={fileInputRef}
                className="upload-div-input"
                type="file"
                accept=".xlsx, .csv"
                hidden
                onChange={handleLoadFile}
              />
            </div>
          )}
        </div>

        {fileLoaded != null && (
          <div className="afterfileloadedcont">
            <p>{fileLoaded.name}</p>
            <svg
              onClick={handleClearFile}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="#667085"
                strokeWidth="1.33"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>

      <div className="btnCont">
        <Button
          disable={false}
          size={"lg"}
          onClick={handleClose}
          hierarchy={{
            buttonText: "Cancel",
            type: "secondaryGrey",
          }}
        />
        <Button
          disable={fileLoaded == null}
          size={"lg"}
          onClick={handleSubmitFile}
          hierarchy={{
            buttonText: "Submit",
            type: "primary",
          }}
        />
      </div>
    </div>
  );
}

export default UploadQns;
